/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import areObjectsEqual from"./areObjectsEqual";import isArray from"./isArray";import isPlainObject from"./isPlainObject";const areArraysEqual=function(r,e,a){if(!isArray(r)||!isArray(e))return!1;let i=r.length,t=!1;if(i!==e.length)return!1;1===a&&(t=!0);for(let s=0;s<i;s++)if(isPlainObject(r[s])&&isPlainObject(e[s])){if(!t&&!areObjectsEqual(r[s],e[s],a-1))return!1}else if(isArray(r[s])&&isArray(e[s])){if(!t&&!areArraysEqual(r[s],e[s],a-1))return!1}else if(r[s]!==e[s])return!1;return!0};export default areArraysEqual;